// Command-app runtime config. MFA enforced server-side (requireMfa; TOTP via Cognito in prod,
// dev-session locally). Command is the tightest surface — also gated by an nginx IP allowlist in
// WF17 (infra, not app code).
export const API_ORIGIN =
  (import.meta.env.VITE_API_ORIGIN as string | undefined)?.replace(/\/+$/, "") ||
  "http://localhost:8787";

// Cognito pool config (DRS-3 terraform). Region is informational — amplify v6 derives it from the
// pool id; the API side uses it to build the issuer/JWKS URLs.
export const COGNITO_REGION =
  (import.meta.env.VITE_COGNITO_REGION as string | undefined) || "us-west-2";

export const COGNITO_USER_POOL_ID =
  (import.meta.env.VITE_COGNITO_USER_POOL_ID as string | undefined) || "";

// This app's SPA client (cc-command scope on the API side). USER_SRP_AUTH, no client secret.
export const COGNITO_CLIENT_ID =
  (import.meta.env.VITE_COGNITO_CLIENT_ID as string | undefined) || "";

export const COGNITO_ENABLED = COGNITO_USER_POOL_ID.length > 0 && COGNITO_CLIENT_ID.length > 0;

// Command portal is bound to its own email domains. Enforced in the API (requirePortalDomain +
// cognito:groups); this copy just sets the expectation up front so a rejected off-domain login is
// self-explanatory. Mirror of AUTH_COMMAND_DOMAINS on the API.
export const STAFF_DOMAINS = ["forcebase.ai"];

// Idle auto-logout. This portal timer is the actual idle control (it resets on activity); the API's
// SESSION_IDLE_MS.command is the canonical budget and must match this value. 20m for a
// privileged back-office. Surfaced by the API at GET /v1/command/settings.session_idle_ms.
export const IDLE_TIMEOUT_MS = 20 * 60 * 1000;
